import { render, staticRenderFns } from "./iconGroupEdit.vue?vue&type=template&id=31f72c16"
import script from "./iconGroupEdit.vue?vue&type=script&lang=js"
export * from "./iconGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports